<template>
  <section>
    <v-container fluid v-if="!isOpenAgent">
      <!-- Breadcrumb and graphics -->
      <v-row>
        <v-col cols="auto" class="px-0">
          <v-btn @click="backAction" icon color="primary" fab small>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="auto" class="d-flex align-center">
          <p class="text-h6 mb-0" v-if="title">{{ title }}</p>
        </v-col>
        <v-col cols="auto" class="ml-auto">
          <v-switch
            v-model="isOpenGraph"
            inset
            class="mt-0"
            label="Ver gráficas"
            hide-details
          ></v-switch>
        </v-col>
      </v-row>

      <!-- Search field -->
      <v-row class="justify-end align-center" style="min-height:68px">
        <v-col cols="auto">
          <v-text-field
            v-model="search"
            @click="isOpenSearch = true"
            append-icon="mdi-magnify"
            label="Buscar"
            filled
            rounded
            dense
            single-line
            hide-details
            readonly
          ></v-text-field>
        </v-col>
      </v-row>

      <!-- Card -->
      <v-card class="shadow-1 mt-5 mt-md-10">
        <!-- Table -->
        <v-data-table
          v-if="!isOpenGraph"
          :search="search"
          :headers="headers"
          :items="agentList"
          item-key="id"
          :loading="isLoading"
          :options.sync="options"
          :server-items-length="totalItems"
          no-data-text="No hay registros que mostrar"
          :footer-props="{
            'items-per-page-options': [15, 30, 50, 100],
          }"
          show-expand
          single-expand
        >
          <template v-slot:[`item.action`]="{ item }">
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                icon
                :color="hover ? 'accent' : 'blue-grey'"
                @click.stop="openAgentDetails(item)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </v-hover>
          </template>
          <template v-slot:expanded-item="{ item }">
            <td colspan="9">
              <v-row v-if="item.register_typing" class="pl-15 pt-8 pb-5">
                <v-chip
                  v-for="register in item.register_typing"
                  :key="register.typification_id"
                  class="mx-2 mb-3"
                  color="primary"
                  text-color="white"
                >
                  <v-avatar left class="primary darken-2">
                    {{ register.total_asset }}
                  </v-avatar>
                  {{ register.typification.name }}
                  <v-icon class="mx-2">mdi-chevron-double-right</v-icon>
                  {{ register.children.name }}
                </v-chip>
              </v-row>
            </td>
          </template>
        </v-data-table>

        <!-- Gráficas -->
        <v-container v-else fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" md="5" v-if="render">
              <v-card outlined>
                <v-card-text>
                  <apexchart
                    ref="chart5"
                    type="donut"
                    :options="optionsDonut"
                    :series="donutSeries"
                  ></apexchart>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-else-if="!render" cols="12" md="5">
              <v-skeleton-loader
                transition="scale-transition"
                class="mx-auto"
                type="card"
              >
              </v-skeleton-loader>
            </v-col>

            <v-col v-if="render" cols="12" md="6">
              <v-card outlined>
                <v-card-text>
                  <apexchart
                    ref="chart7"
                    type="bar"
                    :options="optionsBar"
                    :series="barSeries"
                  ></apexchart>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-else cols="12" md="6">
              <v-skeleton-loader
                transition="scale-transition"
                class="mx-auto"
                type="card"
              >
              </v-skeleton-loader>
            </v-col>

            <v-col cols="12" md="5" v-if="render">
              <v-card outlined>
                <v-card-text>
                  <apexchart
                    ref="chart6"
                    type="donut"
                    :options="optionsDonut2"
                    :series="donutSeries2"
                  ></apexchart>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-else-if="!render" cols="12" md="5">
              <v-skeleton-loader
                transition="scale-transition"
                class="mx-auto"
                type="card"
              >
              </v-skeleton-loader>
            </v-col>

            <v-col v-if="render" cols="12" md="6">
              <v-card outlined>
                <v-card-text>
                  <apexchart
                    ref="chart7"
                    type="bar"
                    :options="optionsBar2"
                    :series="barSeries2"
                  ></apexchart>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-else cols="12" md="6">
              <v-skeleton-loader
                transition="scale-transition"
                class="mx-auto"
                type="card"
              >
              </v-skeleton-loader>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>

    <agent-details
      v-if="isOpenAgent"
      :title="agentSelected.name"
      :queueTitle="title"
      :idAgent="agentSelected.id"
      :idQueue="idQueue"
      @close:agent="closeAgentDetails"
    ></agent-details>

    <search-dialog
      :isActive="isOpenSearch"
      @dialog:close="closeSearch"
      type="agentList"
      :idQueue="idQueue"
    ></search-dialog>
  </section>
</template>

<script>
import AgentDetails from "./AgentDetails.vue";
import { PbxHttpClient } from "@/services/httpclient";
import SearchDialog from "../../components/TypificationReport/SearchDialog.vue";
import getSearchString from "@/components/TypificationReport/getSearchString";

export default {
  components: { AgentDetails, SearchDialog },
  name: "queueList",
  props: {
    title: {
      type: String,
    },
    idQueue: {
      type: Number,
    },
  },

  data() {
    return {
      isLoading: false,
      isOpenAgent: false,
      isOpenGraph: false,
      render: false,
      isOpenSearch: false,
      search: "",
      searchParams: {},
      // For pagination
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      totalItems: 0,
      // End for pagination
      agentList: [],
      agentSelected: {},
      headers: [
        {
          text: "Nombre de Agente",
          align: "left",
          value: "name",
          class: "primary--text",
          width: "20%",
        },
        // {
        //   text: "Email",
        //   align: "left",
        //   value: "email",
        //   class: "primary--text",
        //   width: "20%",
        // },
        {
          text: "Extension",
          value: "extension",
          class: "primary--text",
          width: "20%",
        },
        {
          text: "Cantidad",
          value: "register_typing_count",
          class: "primary--text",
          width: "30%",
        },
        {
          text: "Acciones",
          value: "action",
          class: "primary--text",
          width: "10%",
          align: "left",
          sortable: false,
        },
      ],
      optionsDonut: {
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%",
              },
            },
          },
        ],
        tooltip: {
          y: {
            formatter: (el) => `${el.toFixed(0)} %`,
          },
        },
        width: "100%",
        legend: {
          position: "bottom",
        },
        title: {
          text: "Participacion de Agentes en %",
        },
        dataLabels: { enabled: false },
        labels: [],
      },
      optionsDonut2: {
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: "100%",
              },
            },
          },
        ],
        width: "100%",
        legend: {
          position: "bottom",
        },
        title: {
          text: "Distribucion de tipificacion en %",
        },
        dataLabels: { enabled: false },
        labels: [],
      },
      optionsBar: {
        xaxis: {
          categories: [],
        },
        title: {
          text: "Registros Tipificados por Agentes",
        },
        fill: {
          colors: ["#6D71F9"],
        },
      },
      optionsBar2: {
        xaxis: {
          categories: [],
        },
        chart: {
          stacked: true,
          toolbar: {
            show: true,
          },
          zoom: {
            enabled: true,
          },
        },
        title: {
          text: "Tipificación por Agente",
        },
        plotOptions: {
          bar: {
            horizontal: false,
            borderRadius: 10,
          },
        },
      },
      donutSeries: [],
      donutSeries2: [],
      barSeries: [],
      barSeries2: [],
    };
  },
  created() {
    this.getGraphics();
  },

  watch: {
    options: {
      handler() {
        this.getAgentsByQueue();
      },
      deep: true,
    },
    search() {
      this.getAgentsByQueue();
    },
  },

  methods: {
    async getAgentsByQueue() {
      const { page } = this.options || 1;
      const itemPerPage = this.options.itemsPerPage || 15;
      this.isLoading = true;
      try {
        const { data } = await PbxHttpClient.get(
          `/typing/report/register/${this.idQueue}`,
          {
            params: {
              ...this.searchParams,
              page,
              itemPerPage,
            },
          }
        );
        this.agentList = data.data;
        this.totalItems = data.total;
        this.optionsDonut.labels = data.data.map((el) => el.name);
      } catch (err) {
        this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
      }
      this.isLoading = false;
    },
    async getGraphics(dateStart, dateEnd) {
      try {
        this.render = false;
        const { data } = await PbxHttpClient.get(
          `/typing/report/graphi/register/${this.idQueue}`,
          {
            params: { dateStart, dateEnd },
          }
        );
        const totalTypos = data.table.reduce(
          (acc, el) => acc + el.register_typing_count,
          0
        );
        this.optionsDonut.labels = data.table.map((el) => el.name);
        this.optionsDonut2.labels = data.tipificaction.reduce(
          (acc, { register_typing, name }) => [
            ...acc,
            ...register_typing.map(
              ({ children }) => `${name} - ${children.name}`
            ),
          ],
          []
        );
        this.optionsBar2.xaxis.categories = data.table.map((el) => el.name);
        this.optionsBar.xaxis.categories = this.optionsBar2.xaxis.categories;
        this.donutSeries = data.table.map(
          (el) => (el.register_typing_count * 100) / totalTypos
        );
        this.donutSeries2 = data.tipificaction.reduce(
          (acc, { register_typing }) => [
            ...acc,
            ...register_typing.map(({ total_asset }) => total_asset),
          ],
          []
        );

        this.barSeries = [
          {
            name: "Cantidad",
            data: data.table.map((el) => el.register_typing_count),
          },
        ];
        const barData = data.table.reduce((acc, { register_typing }) => {
          let newAcc = [...acc];
          for (let register of register_typing) {
            if (newAcc.find(({ name }) => name === register.children.name))
              newAcc = newAcc.map((reg) =>
                reg.name === register.children.name
                  ? { ...reg, data: [...reg.data, register.total_asset] }
                  : reg
              );
            else
              newAcc = [
                ...newAcc,
                { name: register.children.name, data: [register.total_asset] },
              ];
          }
          return newAcc;
        }, []);
        this.barSeries2 = barData;

        console.log(barData)

        this.render = true;
      } catch (err) {
        // console.log(err);
        this.$snotify.error("No se pudo obtener los datos.", "¡Error!");
      }
    },
    openAgentDetails(item) {
      this.agentSelected = item;
      this.isOpenAgent = true;
    },
    closeAgentDetails() {
      this.agentSelected = {};
      this.isOpenAgent = false;
    },
    closeSearch(params) {
      this.searchParams = params;
      this.search =
        Object.keys(params).length === 0 ? "" : getSearchString(params);
      this.isOpenSearch = false;

      const arrayParams = this.search.split(",");
      const dateStart = arrayParams
        .find((item) => item.startsWith("desde="))
        .slice(6);
      const dateEnd = arrayParams
        .find((item) => item.startsWith("hasta="))
        .slice(6);

      if (dateStart.length > 0) this.getGraphics(dateStart, dateEnd);
    },
    backAction() {
      this.$emit("close:queue");
    },
  },
};
</script>

<style></style>
